import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { variant } from 'styled-system';
import Link from '@material-ui/core/Link';

const AuthButton = styled('button')(
  {
    width: '160px',
    height: '40px',
    borderRadius: '30px',
    fontSize: '16px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    outline: 'none',
    webkitTapHignlightColor: 'transparent',
  },
  variant({
    variants: {
      primary: {
        color: 'white',
        backgroundColor: 'transparent',
        border: '1px solid white',
        fontSize: '16px',
        marginRight: '24px',
      },
      secondary: {
        color: '#013957',
        backgroundColor: 'white',
        borderColor: 'white',
        borderStyle: 'none',
        '&:hover': {
          backgroundColor: '#f2f2f2', //#very-light-pink
        },
      },
      outlinedBlue: {
        color: '#013957',
        backgroundColor: 'transparent',
        border: '1px solid #013957',
        '&:hover' : {
          color: 'white',
          backgroundColor: '#35b9b6',
          border: 'none'
      }
      }
    },
  })
);

const Button = props => (
  <ThemeProvider theme={{}}>
    <Link href={props.direction}>
      <AuthButton {...props}>{props.children}</AuthButton>
    </Link>
  </ThemeProvider>
);

export default Button;
